import { render, staticRenderFns } from "./commentTaskOngoing.vue?vue&type=template&id=644854cc&scoped=true&"
import script from "./commentTaskOngoing.vue?vue&type=script&lang=js&"
export * from "./commentTaskOngoing.vue?vue&type=script&lang=js&"
import style0 from "./commentTaskOngoing.vue?vue&type=style&index=0&id=644854cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644854cc",
  null
  
)

export default component.exports